import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

import { Grid, makeStyles, useTheme } from "@material-ui/core";

/**
 * Layout component for any type of child, but <Grid item /> can utilize size props (xs, md, etc...)
 */

const useStyles = makeStyles((theme) => ({
  spaceContents: {
    "& > *": {
      // direct children of spaceContents class
      padding: theme.spacing(2),
    },
    "& > * + *": {
      // adjacent siblings of first direct child in spaceContents class
      padding: theme.spacing(0, 2, 2, 2),
    },
  },
}));

const SectionGridContainer = ({
  children,
  background,
  spaceContents,
  component,
  style,
  className,
  gridProps,
  testId,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Grid
      component={component}
      item
      container
      className={clsx(spaceContents && classes.spaceContents, className)}
      style={{ background: background || theme.palette.background.paper, ...style }}
      data-testid={testId}
      {...gridProps}
    >
      {children}
    </Grid>
  );
};

SectionGridContainer.propTypes = {
  children: PropTypes.node.isRequired,
  component: PropTypes.string,
  background: PropTypes.string,
  spaceContents: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  gridProps: PropTypes.object,
  testId: PropTypes.string,
};

SectionGridContainer.defaultProps = {
  component: "section",
  background: null, // theme related defaults should always be applied in component
  spaceContents: false,
  style: {},
  className: null,
  gridProps: {},
  testId: null,
};

export default SectionGridContainer;
